import React from 'react';
import {
  BupSpinner,
  CourseElement,
  PageLayout,
  // SelectCard,
} from '@BUP/components';
import {
  useAuth,
  useGetDashboardResponses,
  useGetSurveysSociogram,
} from '@BUP/hooks';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './dashboard-sociogram.module.css';

const DashboardPage = () => {
  // const [selectedCourseIds, setSelectedCourseIds] = useState([]);
  // const handleSelectCourse = (courseId) => {
  //   setSelectedCourseIds(courseId);
  // };
  // const selectedCourses = data.filter((course) =>
  //   selectedCourseIds.includes(course.id)
  // );
  const { user } = useAuth();
  const [t] = useTranslation();
  const { sociogram, isLoadingSurveySociogram } = useGetSurveysSociogram(user);
  const { organizationResults } = useGetDashboardResponses(sociogram);

  return (
    <PageLayout pageName={t('pages.data.dashBoardSociogram.title')} backButton>
      {/* <div>
        <SelectCard
          data={data}
          selectedCourse={selectedCourseIds}
          onSelectCourse={handleSelectCourse}
        />
      </div> */}
      {isLoadingSurveySociogram ? (
        <BupSpinner size="large" />
      ) : (
        <Row className={styles.cards_wrapper} gutter={[30, 50]}>
          {organizationResults.map((course) => (
            <Col xs={14} md={8} lg={6} xxl={4} key={`course-${course?.id}`}>
              <CourseElement course={course} />
            </Col>
          ))}
        </Row>
      )}
    </PageLayout>
  );
};
export default DashboardPage;
